<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('appManage.title') }}</span>
            <div class="card-header-right">
              <el-button type="primary" size="small" @click="openAddAppModal" icon="el-icon-plus">
                {{ $t('appManage.addApp') }}
              </el-button>
            </div>
          </div>
          <div class="card-body">
            <el-table :data="appManageInfo.apps" style="width: 100%" border stripe>
              <el-table-column prop="appId" :label="$t('appManage.appId')" align="center" />
              <el-table-column prop="name" :label="$t('appManage.appName')" align="center" />
              <el-table-column prop="whileListIp" :label="$t('appManage.whiteList')" align="center" />
              <el-table-column prop="blackListIp" :label="$t('appManage.blackList')" align="center" />
              <el-table-column :label="$t('appManage.operations')" align="center" width="200">
                <template slot-scope="scope">
                  <el-button size="mini" @click="openEditAppModal(scope.row)">
                    {{ $t('appManage.edit') }}
                  </el-button>
                  <el-button size="mini" type="danger" @click="openDeleteAppModal(scope.row)">
                    {{ $t('appManage.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination class="pagination" @current-change="handleCurrentChange"
              :current-page="pagination.currentPage" :page-size="pagination.pageSize"
              layout="total, prev, pager, next, jumper" :total="appManageInfo.total" />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-app ref="addAppModal" @success="listApps" />
    <edit-app ref="editAppModal" @success="listApps" />
    <delete-app ref="deleteAppModal" @success="listApps" />
  </div>
</template>

<script>
import { listApps } from '@/api/dev/appApi'
import AddApp from '@/components/dev/addApp/addApp.vue'
import EditApp from '@/components/dev/editApp/editApp.vue'
import DeleteApp from '@/components/dev/deleteApp/deleteApp.vue'

export default {
  name: 'AppManage',
  components: {
    AddApp,
    EditApp,
    DeleteApp
  },
  data() {
    return {
      appManageInfo: {
        apps: [],
        total: 0
      },
      pagination: {
        currentPage: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.listApps()
  },
  methods: {
    async listApps() {
      try {
        const params = {
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }
        const res = await listApps(params)
        this.appManageInfo.apps = res.data
        this.appManageInfo.total = res.total
      } catch (error) {
        console.error('获取应用列表失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.listApps()
    },
    openAddAppModal() {
      this.$refs.addAppModal.open()
    },
    openEditAppModal(app) {
      this.$refs.editAppModal.open(app)
    },
    openDeleteAppModal(app) {
      this.$refs.deleteAppModal.open(app)
    }
  }
}
</script>

<style scoped>
.card-header-right {
  float: right;
  padding: 3px 0;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>